import { render } from "./TicketReservation copy.vue?vue&type=template&id=7dc3bb11&scoped=true"
import script from "./TicketReservation copy.vue?vue&type=script&lang=js"
export * from "./TicketReservation copy.vue?vue&type=script&lang=js"

import "./TicketReservation copy.vue?vue&type=style&index=0&id=7dc3bb11&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc3bb11"]])

export default __exports__